module.exports = __webpack_public_path__ + "static/step3-6422838da03ca80b021feae918f5b438.png";